/**
 * This is the configuration for the sidebar menus.  Note that the menu id's must be a zero-based
 * index approach as that is how the Accordion tracks active menus (by index).  ALso, the order
 * is important: the order here will be reflected as the order in the sidebar menu.
 */
import { RESOURCES } from './permissions'

// const MENU_HOME = 'home'  // currently we have no menu to access the HOME database...
const MENU_DASHBOARD = 'dashboard'
const MENU_MARKETPLACE = 'marketplace'
const MENU_PROPERTY = 'property'
const MENU_TRANSACTIONS = 'transactions'
const MENU_SCHEDULE = 'schedule'
const MENU_SYNC = 'sync'
const MENU_ADMIN = 'admin'

const menus = [
  {
    id: 0,
    dataElmId: MENU_DASHBOARD,
    title: 'Dashboards',
    iconName: 'dashboard',
    items: [
      {
        url: '/dashboard',
        title: 'Home',
        id: 'home',
      },
    ],
  },
  {
    id: 1,
    dataElmId: MENU_MARKETPLACE,
    title: 'Marketplace',
    iconName: 'handshake outline',
    items: [
      {
        url: '/property/documents',
        title: 'Documents',
        id: 'documents',
        resource: RESOURCES.DOCUMENTS_PAGE,
      },
      {
        url: '/property/packages',
        title: 'Packages',
        id: 'packages',
        resource: RESOURCES.PACKAGES_PAGE,
      },
      {
        url: '/property/listing-attributes',
        title: 'Listing Attributes',
        id: 'listing_attributes',
        resource: RESOURCES.LISTING_ATTRIBUTES_PAGE,
      },
      {
        url: '/property/marketing-tags',
        title: 'Marketing Tags',
        id: 'marketing_tags',
        resource: RESOURCES.MARKETING_TAGS_PAGE,
      },
      {
        url: '/invitations',
        title: 'Invitations',
        id: 'invitations',
        resource: RESOURCES.INVITATIONS_PAGE,
      },
    ],
  },
  {
    id: 2,
    dataElmId: MENU_PROPERTY,
    title: 'Property Listings',
    iconName: 'home',
    items: [
      {
        url: '/property/properties',
        title: 'Properties',
        id: 'properties',
        resource: RESOURCES.PROPERTIES_PAGE,
      },
      {
        url: '/property/listings',
        title: 'Listings',
        id: 'listings',
        resource: RESOURCES.LISTINGS_PAGE,
      },
      {
        url: '/property/intake',
        title: 'Intake Hub',
        id: 'intake_hub',
        resource: RESOURCES.INTAKE_HUB_PAGE,
      },
    ],
  },
  {
    id: 3,
    dataElmId: MENU_TRANSACTIONS,
    title: 'Transactions',
    iconName: 'dollar',
    items: [
      {
        url: '/property/contracting',
        title: 'Contracting',
        id: 'contracting',
        resource: RESOURCES.TRANSACTION_MANAGER_PAGE,
      },
      {
        url: '/auctioneer-dashboard',
        title: 'Auctioneer Dashboard',
        id: 'auctioneer_dashboard',
        resource: RESOURCES.AUCTIONEER_DASHBOARD_PAGE,
      },
      {
        url: '/auctioneer-dashboard/live-auction-tracker',
        title: 'Live Auction Check In/Out Tracker',
        id: 'live_auction_tracker',
        resource: RESOURCES.AUCTIONEER_LIVE_AUCTION_TRACKER_PAGE,
      },
    ],
  },
  {
    id: 4,
    dataElmId: MENU_SCHEDULE,
    title: 'Auction Scheduler',
    iconName: 'calendar alternate',
    items: [
      {
        url: '/schedule/events',
        title: 'Events',
        id: 'events',
        resource: RESOURCES.EVENTS_PAGE,
      },
      {
        url: '/schedule/venues',
        title: 'Venues',
        id: 'venues',
        resource: RESOURCES.VENUES_PAGE,
      },
      {
        url: '/schedule/event-templates',
        title: 'Event Templates',
        id: 'event_templates',
        resource: RESOURCES.EVENT_TEMPLATES_PAGE,
      },
      {
        url: '/schedule/venue-templates',
        title: 'Venue Templates',
        id: 'venue_templates',
        resource: RESOURCES.VENUE_TEMPLATES_PAGE,
      },
    ],
  },
  {
    id: 5,
    dataElmId: MENU_SYNC,
    title: 'Logs',
    iconName: 'exchange',
    items: [
      {
        url: '/sync/morpheus-logs',
        title: 'Morpheus',
        id: 'morpheus',
        resource: RESOURCES.MORPHEUS_LOGS_PAGE,
      },
    ],
  },
  {
    id: 6,
    dataElmId: MENU_ADMIN,
    title: 'Admin',
    iconName: 'cogs',
    items: [
      {
        url: '/user-management',
        title: 'Users',
        id: 'users',
        resource: RESOURCES.USERS_PAGE,
      },
      {
        url: '/client-authorization',
        title: 'Client Authorization',
        id: 'client_authorization',
        resource: RESOURCES.CLIENT_AUTHORIZATION_PAGE,
      },
      {
        url: '/email-template-management',
        title: 'Email Templates',
        id: 'email_templates',
        resource: RESOURCES.EMAIL_TEMPLATE_MANAGEMENT_PAGE,
      },
      {
        url: '/tiny-url',
        title: 'Tiny Urls',
        id: 'tiny_urls',
        resource: RESOURCES.TINY_URL_PAGE,
      },
      {
        url: '/communications',
        title: 'Communications',
        id: 'communications',
        resource: RESOURCES.COMMUNICATIONS_PAGE,
      },
    ],
  },
]

export default menus
